import { render } from "./ComponentSideBar.vue?vue&type=template&id=51b1f06f&scoped=true"
import script from "./ComponentSideBar.vue?vue&type=script&lang=js"
export * from "./ComponentSideBar.vue?vue&type=script&lang=js"

import "./ComponentSideBar.vue?vue&type=style&index=0&id=51b1f06f&scoped=true&lang=css"

import exportComponent from "/home/avatar_asi_napoli/avatar.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b1f06f"]])

export default __exports__